import { baseApi, client } from '../baseApi.ts';

export const apiKeyEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		resetApiKey: builder.mutation({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.apiKey.reset();
					return { data: response.data };
				} catch (error) {
					return { error };
				}
			},
		}),
		generateApiKey: builder.mutation({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.apiKey.generate();
					return { data: response.data };
				} catch (error) {
					return { error };
				}
			},
		}),
	}),
});
